export const deviceSyncOperationNames = {
  STARTED: 'Started',
  ENDED: 'Ended',
}

export const deviceSyncEventName = 'device-sync'

export const deviceSyncEventFinishedName = 'device-sync-finished'
